// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.subtitle[data-v-1b11f862] {\n\tfont-size: 1.2rem;\n\tfont-weight: 300;\n\tline-height: 1.2;\n}\n", ""]);
// Exports
module.exports = exports;
